// removed by extract-text-webpack-plugin
module.exports = {"overlay":"overlay__overlay--efHWk","overlayAppear":"overlay__overlayAppear--3rFlL","exit":"overlay__exit--1iAue","overlayFade":"overlay__overlayFade--1lFTF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Overlay/overlay.css
// module id = jeRJ
// module chunks = 0